import { Suspense, ReactNode } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ROUTES } from "@/domain/constants/routes";

// 組件導入
import { SmartRouter } from "./SmartRouter";
import { ProtectedRoute } from "./ProtectedRoute";
import {
  HomePage,
  // ChatPage,
  LoginPage,
  ProfilePage,
  TermsPage,
  PrivacyPage,
  NotFoundPage,
  PermissionDeniedPage,
  ConversationPage,
  AgentListPage,
  AccountInitPage,
} from "@/ui/pages";

/**
 * 建立受保護路由
 * @param path 路徑
 * @param element 要渲染的組件
 * @returns 路由組件
 */
const createProtectedRoute = (path: string, element: ReactNode) => (
  <Route path={path} element={<ProtectedRoute>{element}</ProtectedRoute>} />
);

/**
 * 建立多個使用相同組件的受保護路由
 * @param paths 路徑列表
 * @param element 要渲染的組件
 * @returns 路由組件數組
 */
const createProtectedRoutes = (paths: string[], element: ReactNode) =>
  paths.map((path) => createProtectedRoute(path, element));

/**
 * 應用路由組件
 * 集中管理所有路由配置
 */
export function AppRouter() {
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="flex items-center justify-center min-h-screen">
            <div className="animate-pulse text-gray-700 dark:text-gray-300">
              載入中...
            </div>
          </div>
        }
      >
        <SmartRouter>
          <Routes>
            {/* 公開路由 */}
            <Route path={ROUTES.HOME} element={<HomePage />} />
            <Route path={ROUTES.LOGIN} element={<LoginPage />} />
            <Route path={ROUTES.TERMS} element={<TermsPage />} />
            <Route path={ROUTES.PRIVACY} element={<PrivacyPage />} />

            {/* 會話相關路由 - 使用 ConversationPage */}
            {createProtectedRoutes([ROUTES.ACCOUNT_INIT], <AccountInitPage />)}

            {/* 會話相關路由 - 使用 ConversationPage */}
            {createProtectedRoutes([ROUTES.CONVERSATION], <ConversationPage />)}

            {/* TODO */}
            {/* 代理列表路由 - 使用 AgentListPage */}
            {createProtectedRoutes([ROUTES.AGENTS], <AgentListPage />)}

            {/* 個人資料路由 */}
            {createProtectedRoute(ROUTES.PROFILE, <ProfilePage />)}

            {/* 聊天路由 - 使用特定組件 */}
            {/* {createProtectedRoute(ROUTES.CHAT_BUILDING, <ChatPage />)} */}

            {/* 404 頁面路由 */}
            <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage />} />

            {/* 403 權限拒絕頁面路由 */}
            <Route
              path={ROUTES.PERMISSION_DENIED}
              element={<PermissionDeniedPage />}
            />

            {/* 捕獲所有未匹配的路由，導向 404 頁面 */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </SmartRouter>
      </Suspense>
    </BrowserRouter>
  );
}
